import { toPng } from '@intuiface/html-to-image'

const waitForImage = img => {
  if (!img) return Promise.resolve()
  if (img.complete && img.naturalWidth > 0) return Promise.resolve()

  return new Promise(resolve => {
    let settled = false

    const finish = () => {
      if (settled) return
      settled = true
      clearTimeout(timeoutId)
      img.removeEventListener("load", finish)
      img.removeEventListener("error", finish)
      resolve()
    }

    const timeoutId = setTimeout(finish, 2000)
    img.addEventListener("load", finish, { once: true })
    img.addEventListener("error", finish, { once: true })
  })
}

const waitForImagesInNode = async node => {
  const images = Array.from(node.querySelectorAll("img"))
  if (!images.length) return
  await Promise.all(images.map(waitForImage))
}

const swapCaptureSources = node => {
  const images = Array.from(node.querySelectorAll("img[data-capture-src]"))
  const originalSrc = images.map(img => img.getAttribute("src"))

  images.forEach(img => {
    const captureSrc = img.getAttribute("data-capture-src")
    if (captureSrc) img.setAttribute("src", captureSrc)
  })

  return () => {
    images.forEach((img, idx) => {
      const src = originalSrc[idx]
      if (src) img.setAttribute("src", src)
    })
  }
}

const captureGoogleFrontPreview = async () => {
  const node = document.getElementById('googleFront')
  if (!node) throw new Error('Google front preview node not found')

  node.classList.add("preview")
  const restoreCaptureSources = swapCaptureSources(node)

  try {
    await waitForImagesInNode(node)
    return await toPng(node, { cacheBust: true })
  }
  finally {
    restoreCaptureSources()
    node.classList.remove("preview")
  }
}

export default captureGoogleFrontPreview
